// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/app/components/dialogs/components/ComparisonCheckRow.module.css';
import {CheckIcon} from '@phosphor-icons/react';
import {observer} from 'mobx-react-lite';
export const ComparisonCheckRow = observer(
	({feature, freeHas, plutoniumHas}: {feature: string; freeHas: boolean; plutoniumHas: boolean}) => (
		<div className={styles.row}>
			<div className={styles.feature}>
				<p className={styles.featureText}>{feature}</p>
			</div>
			<div className={styles.valuesContainer}>
				<div className={styles.valueCell}>
					{freeHas ? <CheckIcon className={styles.checkIcon} weight="bold" /> : <span className={styles.dash}>—</span>}
				</div>
				<div className={styles.valueCell}>
					{plutoniumHas ? (
						<CheckIcon className={styles.checkIcon} weight="bold" />
					) : (
						<span className={styles.dash}>—</span>
					)}
				</div>
			</div>
		</div>
	),
);
